// plugins/nprogress.js
import { defineNuxtPlugin } from '#app'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

export default defineNuxtPlugin((nuxtApp) => {
  if (import.meta.client) {
    const router = useRouter()
    NProgress.configure({ showSpinner: false })

    // 路由开始时启动进度条
    router.beforeEach((to, from, next) => {
      NProgress.start()
      next()
    })

    // 页面加载完毕后结束进度条
    nuxtApp.hook('page:finish', () => {
      NProgress.done()
    })

    // 处理路由跳转的错误
    router.onError(() => {
      NProgress.done()
    })
  }
})
